import { useMemo, useState } from "react";
import { Plus, Search } from "lucide-react";
import { useCan, useLoad } from "@/lib/api";
import { ErrorBox, PageHeading } from "@/components/common";
import ClinicalForm from "@/components/forms/ClinicalForm";
import { ClinicalList } from "@/components/ledgerLists";

export default function ClinicalRecords() {
  const can = useCan();
  const [show, setShow] = useState(false);
  const [q, setQ] = useState("");
  const { data, error, reload } = useLoad("/clinical-records", []);
  const rows = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? data.filter((r) => `${r.patient_name} ${r.opd} ${r.diagnosis} ${r.chief_complaint} ${r.procedures} ${r.tooth_numbers}`.toLowerCase().includes(s)) : data;
  }, [data, q]);
  return (
    <div className="content">
      <PageHeading eyebrow="CLINICAL RECORDS / VISIT NOTES" title="Every visit," accent="documented." sub="Examination, diagnosis, radiographs and procedures, visit by visit.">
        {can("clinical:write") && <button className="primary" onClick={() => setShow(true)} data-testid="add-clinical-button"><Plus size={18} /> New visit note</button>}
      </PageHeading>
      <div className="toolbar"><div className="search"><Search size={17} /><input data-testid="clinical-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search patient, diagnosis, tooth" /></div><span className="result-count" data-testid="clinical-count">{rows.length} records</span></div>
      <ErrorBox error={error} testid="clinical-error" />
      <ClinicalList rows={rows} onChanged={reload} />
      {show && <ClinicalForm onClose={() => setShow(false)} onSaved={() => { setShow(false); reload(); }} />}
    </div>
  );
}
